export class DeselectSelectedUsers {
    static readonly type = '[User] DeselectSelectedUsers';
}
